import HeaderComponent from "../HeaderComponent";
import SectionComponent from "../SectionComponent";
import ImageComponent from "../ImageComponent";
import NavigationContainerComponent from "../NavigationContainerComponent";
import NavItemComponent from "../NavItemComponent";
import CartComponent from "../CartComponent";
import TextComponent from "../TextComponent";
import EventComponent from "../Events/EventComponent";

export var defaultComponents: { [key: string]: any } = {
  header: HeaderComponent,
  section: SectionComponent,
  image: ImageComponent,
  "navigation-container": NavigationContainerComponent,
  "nav-item": NavItemComponent,
  cart: CartComponent,
  text: TextComponent,
  eventComponent: EventComponent,
};
